import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import { capitalizeSingleWord } from 'utils/helpers/format';

const StatusChip = ({ status }) => {
  const isCompleted = R.equals(status, 'COMPLETED');
  const isDraft = R.equals(status, 'DRAFT');
  const isScheduled = R.equals(status, 'SCHEDULED');
  const isPending = R.equals(status, 'PENDING');
  const isWarning = R.equals(status, 'WARNING');

  const statusBoxStyles = {
    alignItems: 'center',
    backgroundColor: isCompleted
      ? 'success.light'
      : isDraft
      ? 'surface.medium'
      : isScheduled
      ? 'primary.lighter'
      : isPending
      ? 'warning.light'
      : 'error.light', // warning
    borderRadius: 0.5,
    display: 'flex',
    height: 30,
    justifyContent: 'center',
    typography: 'caption',
    width: 82,
  };

  const statusStyles = {
    color: isWarning ? 'error.dark' : 'text.primary',
  };

  return status ? (
    <Box sx={statusBoxStyles}>
      <Box sx={statusStyles}>{capitalizeSingleWord(status)}</Box>
    </Box>
  ) : null;
};

StatusChip.propTypes = {
  status: PropTypes.oneOf(['COMPLETED', 'DRAFT', 'PENDING', 'SCHEDULED', 'WARNING']),
};
StatusChip.defaultProps = {
  status: undefined,
};

export default StatusChip;
